module.exports = __webpack_public_path__ + "static/Inter-SemiBold-d47f00ba904b77983c6c172b39ee2536.woff";